<template>
  <el-form :model="form" :rules="rules" ref="formRef">
    <el-form-item label="手机号" prop="phone">
      <el-input v-model="form.phone"></el-input>
    </el-form-item>
    <el-form-item label="密码" prop="passwordLogin">
      <el-input :type="showPassword ? 'text' : 'password'" v-model="form.passwordLogin" show-password></el-input>
    </el-form-item>
    <el-form-item label="当前位置">
      <el-input placeholder="当前定位的学校" v-model="location.school" disabled>
        <el-button slot="append" @click="fetchLocation" style="transform: translateY(10px);">重新定位</el-button>
        <el-tooltip slot="append" style="transform: translateY(10px);" class="item" effect="dark"
          content="推荐使用edge或Chrome访问，请同意位置授权并不要使用网络代理，否则会导致无法定位或定位出现偏差" placement="top">
          <i style="color: gray;" class="el-icon-info"></i>
        </el-tooltip>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-checkbox v-model="form.remember">记住账号和密码</el-checkbox>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="debouncedLogin">登录</el-button>
      <el-button type="text" @click="$emit('switch-mode')">注册</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import db from "../../api/database";
import { debounce } from 'lodash';
import { checkUserLocation } from '../../api/GPS'; // 导入GPS脚本

export default {
  data() {
    return {
      showPassword: false,
      form: {
        phone: localStorage.getItem('rememberPhone') || '',
        passwordLogin: localStorage.getItem('rememberPassword') || '',
        remember: localStorage.getItem('rememberPhone') ? true : false
      },
      location: {
        school: '定位中...' // 默认显示“定位中”
      },
      rules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur' }],
        passwordLogin: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ]
      }
    };
  },
  created() {
    this.debouncedLogin = debounce(this.login, 300);
    this.initializeLocation();
  },
  methods: {
    initializeLocation() {
      const cachedLocation = JSON.parse(localStorage.getItem('location'));
      if (cachedLocation && cachedLocation.foundSchool) {
        this.location.school = cachedLocation.foundSchool;
      } else {
        this.fetchLocation();
      }
    },
    async fetchLocation() {
      try {
        const locationData = await checkUserLocation();
        console.log("用户位置:", locationData);
        this.$message.success('定位成功');
        this.location.school = locationData.foundSchool || '未能获取学校信息';
        localStorage.setItem('location', JSON.stringify(locationData));
      } catch (error) {
        this.$message.error('定位失败');
        this.location.school = '获取定位失败';
        console.error('获取定位失败:', error);
      }
    },
    async recordLog(type, details = {}) {
      const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
      const phone = user ? user.phone : this.form.phone;
      const location = JSON.parse(localStorage.getItem('location'));

      const locationNew = { foundSchool: user.school }

      const logData = {
        timestamp: new Date().toISOString(),
        type: type,
        phone: phone,
        location: locationNew,
        ...details
      };

      try {
        await db.collection('Logs').add(logData);
        console.log('日志记录成功:', logData);
      } catch (error) {
        console.error('记录日志失败:', error);
      }
    },
    async login() {
      console.log("正在登录...");
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          try {
            const { data } = await db.collection('users').where({
              phone: this.form.phone,
              password: this.form.passwordLogin
            }).get();
            console.log(data);
            console.log(this.form);
            if (data.length > 0) {
              const user = data[0];

              if (this.form.remember) {
                localStorage.setItem('rememberPhone', this.form.phone);
                localStorage.setItem('rememberPassword', this.form.passwordLogin);
              } else {
                localStorage.removeItem('rememberPhone');
                localStorage.removeItem('rememberPassword');
              }
              localStorage.setItem('user', JSON.stringify(user));
              this.$emit('login-success', user);

              // 添加登录成功日志
              this.recordLog('login', {});

              // 登录成功后再获取位置信息
              this.fetchLocation();
            } else {
              this.$message.error('手机号或密码错误');
            }
          } catch (error) {
            this.$message.error('登录失败，请重试');
            console.error(error);
          }
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/LoginForm/loginForm.vue